// Selector de múltiples clasificadores (opcionalmente por tipo).
// Extraído de App.jsx para que lo usen también las páginas en subcarpetas.
import React, { useState, useEffect } from "react";
import { Tag } from "lucide-react";
import { apiFetch, inputStyle, labelStyle, btnSmallInfo, COLORS } from "./ui";
import TipoSelector from "./TipoSelector";

function MultiClassifierFilter({ token, onChange, etiquetas = null }) {
  const [clasificadores, setClasificadores] = useState([]);
  const [loaded, setLoaded] = useState(false);
  // rows: [{ id_clasificador: "", id_tipo: "" }]
  const [rows, setRows] = useState([{ id_clasificador: "", id_tipo: "" }]);

  useEffect(() => {
    apiFetch("/clasificadores", {}, token).then(res => {
      setClasificadores(Array.isArray(res) ? res : []);
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, [token]);

  const updateRow = (idx, field, value) => {
    setRows(prev => {
      const next = prev.map((r, i) => i === idx ? { ...r, [field]: value } : r);
      if (field === "id_clasificador") next[idx].id_tipo = "";
      return next;
    });
  };

  const addRow = () => setRows(prev => [...prev, { id_clasificador: "", id_tipo: "" }]);
  const removeRow = (idx) => {
    setRows(prev => {
      const next = prev.filter((_, i) => i !== idx);
      return next.length === 0 ? [{ id_clasificador: "", id_tipo: "" }] : next;
    });
  };

  // Notify parent whenever rows change after initial load
  useEffect(() => {
    if (loaded && onChange) onChange(rows.filter(r => r.id_clasificador));
  }, [rows, loaded, onChange]);

  if (!loaded) return null;

  // El agrupador es el primer renglón SELECCIONADO: los vacíos no cuentan
  // (el padre también los descarta antes de mandar mclas).
  const idxAgrupador = Math.max(0, rows.findIndex(r => r.id_clasificador));

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <label style={{ ...labelStyle, marginBottom: 2 }}><Tag size={12} style={{ marginRight: 4 }} />Clasificadores (múltiples)</label>
      {rows.map((row, idx) => (
        <div key={idx} style={{ display: "flex", gap: 8, alignItems: "center" }}>
          {etiquetas && (
            <span style={{ fontSize: 11, color: COLORS.textMuted, minWidth: 76 }}>
              {idx === idxAgrupador ? etiquetas.primera : etiquetas.resto}
            </span>
          )}
          <select
            value={row.id_clasificador}
            onChange={e => updateRow(idx, "id_clasificador", e.target.value)}
            style={{ ...inputStyle, minWidth: 160 }}
          >
            <option value="">— Todos —</option>
            {clasificadores.map(c => (
              <option key={c.id_clasificador} value={c.id_clasificador}>
                {c.nombre_clasificador || c.id_clasificador}
              </option>
            ))}
          </select>
          <TipoSelector
            key={row.id_clasificador}
            token={token}
            clasificador={clasificadores.find(c => c.id_clasificador === row.id_clasificador)}
            value={row.id_tipo}
            onChange={v => updateRow(idx, "id_tipo", v)}
            style={{ minWidth: 140 }}
          />
          {rows.length > 1 && (
            <button
              onClick={() => removeRow(idx)}
              style={{ padding: "4px 8px", background: "#ef444422", border: "1px solid #ef444444", borderRadius: 6, color: "#ef4444", fontSize: 12, cursor: "pointer" }}
            >✕</button>
          )}
        </div>
      ))}
      <button
        onClick={addRow}
        style={{ ...btnSmallInfo, padding: "4px 12px", fontSize: 12, alignSelf: "flex-start" }}
      >+ Agregar clasificador</button>
    </div>
  );
}

export default MultiClassifierFilter;
